export function useCustomNuxtUtils() {
    const stateKeyPrefix = '$s';
    const nuxtApp = useNuxtApp();
    
    const isPostServerRendered = computed(() => import.meta.client && !(nuxtApp.isHydrating && nuxtApp.payload.serverRendered));

    function removeOnceKey(key: MaybeRef<string>): void {
        nuxtApp.payload.once.delete(unref(key));
    }

    function removeOnceKeysByPrefix(prefix: MaybeRef<string>): void {
        prefix = unref(prefix);
        nuxtApp.payload.once.forEach((key) => {
            if (key.startsWith(prefix)) {
                removeOnceKey(key);
            }
        });
    }

    function removeDataKey(key: MaybeRef<string>): void {
        key = unref(key);
        delete nuxtApp.payload.data[key];
    }

    function removeStateByPrefix(prefix: MaybeRef<string>): void {
        prefix = `${stateKeyPrefix}${unref(prefix)}`;
        Object.keys(nuxtApp.payload.state).forEach((key: string) => {
            if (key.startsWith(key)) {
                delete nuxtApp.payload.state[key];
            }
        });
    }

    function clearOnceKeys(): void {
        nuxtApp.payload.once.clear();
    }

    return {
        isPostServerRendered,
        removeOnceKey,
        removeOnceKeysByPrefix,
        removeDataKey,
        removeStateByPrefix,
        clearOnceKeys
    };
}
